module.exports = __webpack_public_path__ + "img/cryptomeda.77c4f043.svg";